"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var _formWrapper = require("../../../../reducers/formWrapper.js");
var _cccisdReduxFormHelpers = require("cccisd-redux-form-helpers");
var _cccisdValidator = _interopRequireDefault(require("cccisd-validator"));
var _style = _interopRequireDefault(require("./style.css"));
var _cross = _interopRequireDefault(require("cccisd-icons/cross3"));
var _cccisdTooltip = _interopRequireDefault(require("cccisd-tooltip"));
var _info = _interopRequireDefault(require("cccisd-icons/info2"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var JsonArray = function JsonArray(props) {
  var label = props.displaySettings.label;
  var originalValue = props.field.value;
  var inputEl = (0, _react.useRef)(null);
  var _useState = (0, _react.useState)(''),
    _useState2 = _slicedToArray(_useState, 2),
    errorMessage = _useState2[0],
    setErrorMessage = _useState2[1];
  (0, _react.useEffect)(function () {
    var initialValue = props.row[props.graphqlSettings.edit.valuePath];
    if (!initialValue) {
      initialValue = '[]';
    }
    props.changeAllFields(initialValue, {
      field: props.field,
      fieldTypes: props.fieldTypes,
      operation: props.operation,
      requiredByFields: props.requiredByFields
    });
  }, []);
  if (!originalValue) {
    originalValue = '[]';
  }
  var parsedValues = JSON.parse(originalValue);
  function handleClickAdd() {
    var newInputValue = inputEl.current.value;
    var validationSettings = _objectSpread({}, props.validationSettings);
    if (!validationSettings.types || !Array.isArray(validationSettings.types)) {
      validationSettings.types = validationSettings.validationType ? [validationSettings.validationType] : [];
    }
    var isValid = (0, _cccisdValidator["default"])(newInputValue, validationSettings);
    if (isValid.status === 'fail') {
      setErrorMessage(isValid.errors[Object.keys(isValid.errors)[0]]);
      return;
    }
    setErrorMessage('');

    // convert to array just to use .push
    var previousValues = props.field.value;
    var previousValuesArray = JSON.parse(previousValues);
    if (previousValuesArray.includes(newInputValue)) {
      setErrorMessage('This value is already entered.');
    } else {
      previousValuesArray.push(newInputValue);
    }

    // convert back to string before saving
    props.changeAllFields(JSON.stringify(previousValuesArray), {
      field: props.field,
      fieldTypes: props.fieldTypes,
      operation: props.operation,
      requiredByFields: props.requiredByFields
    });

    // reset input element back to empty
    inputEl.current.value = '';
  }
  function removeItem(index) {
    var oldValues = props.field.value;
    var oldValuesArray = JSON.parse(oldValues);
    var newValues = oldValuesArray.filter(function (val, i) {
      return i !== index;
    });
    props.changeAllFields(JSON.stringify(newValues), {
      field: props.field,
      fieldTypes: props.fieldTypes,
      operation: props.operation,
      requiredByFields: props.requiredByFields
    });
  }
  var handleKeyPress = function handleKeyPress(event) {
    if (event.key === 'Enter') {
      event.preventDefault();
      handleClickAdd();
    }
  };
  return /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.FieldBlock, {
    field: props.field,
    label: /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, label, ' ', props.displaySettings.toolTip && /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
      title: props.displaySettings.toolTip
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: "text-primary"
    }, /*#__PURE__*/_react["default"].createElement(_info["default"], null))))
  }, /*#__PURE__*/_react["default"].createElement("ul", {
    className: _style["default"].list
  }, parsedValues && parsedValues.map(function (val, index) {
    return /*#__PURE__*/_react["default"].createElement("li", {
      key: index
    }, /*#__PURE__*/_react["default"].createElement("button", {
      className: _style["default"]["delete"],
      type: "button",
      onClick: function onClick() {
        return removeItem(index);
      }
    }, /*#__PURE__*/_react["default"].createElement(_cross["default"], null)), val);
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "form-inline"
  }, /*#__PURE__*/_react["default"].createElement("input", {
    type: "text",
    className: "form-control",
    "aria-label": label,
    ref: inputEl,
    onKeyPress: handleKeyPress
  }), /*#__PURE__*/_react["default"].createElement("button", {
    className: "btn btn-default",
    type: "button",
    onClick: handleClickAdd
  }, "Add")), /*#__PURE__*/_react["default"].createElement("p", {
    className: "text-danger"
  }, errorMessage));
};
var mapStateToProps = function mapStateToProps(state) {
  return {
    reduxForm: state.form
  };
};
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps, {
  changeAllFields: _formWrapper.changeAllFields
})(JsonArray);